
































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";

@Component
export default class DocumentForm extends Vue {
  formData: any = {};
  isSubmitting: boolean = false;
  submitResult: boolean = false;
  isSubmitted: boolean = false;
  spatialOptions: [] = [];
  documentTypes: [] = [];
  frequency: [] = [];
  categories: [] = [];
  subCategories: [] = [];
  correctionTypes: [] = [];
  isNew = true;
  source: any = {};
  isCorrection = false;
  showDocumentFields = false;

  async mounted() {
    this.spatialOptions = (
      await axios.get<[]>("/lookup/spatial-coverage", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.documentTypes = (
      await axios.get<[]>("/lookup/document-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.frequency = (
      await axios.get<[]>("/lookup/frequency", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.correctionTypes = (
      await axios.get<[]>("/lookup/correction-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.categories = (
      await axios.get<[]>("/lookup/categories", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
  }

  async submit() {
    if (this.isSubmitted) return;
    this.isSubmitting = true;

    var plannedDateToSave = new Date(this.formData.planned_publishing_date);
    plannedDateToSave.setHours(plannedDateToSave.getHours() + 12);
    this.formData.planned_publishing_date = plannedDateToSave;

    if (this.formData.actual_publishing_date) {
      var actualDateToSave = new Date(this.formData.actual_publishing_date);
      actualDateToSave.setHours(actualDateToSave.getHours() + 12);
      this.formData.actual_publishing_date = actualDateToSave;
    }

    try {
      await axios.post("/document", this.formData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      });
      this.isSubmitted = true;
      this.submitResult = true;
    } catch {
      this.isSubmitted = true;
      this.submitResult = false;
    }
  }

  GoBack() {
    this.$router.go(-1);
  }

  async loadSubcategories(value) {
    let areaId = value;
    console.log(areaId);
    this.subCategories = (
      await axios.get<[]>("/lookup/subcategories?area=" + areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
  }

  toggleDocumentFields(value) {
     this.showDocumentFields = value > 2 && value !== 7;
  }
}
